import type { CityConfig } from "@/pages/city-template/types";

export const kingstonConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Kingston",
  state: "New York",
  stateAbbr: "NY",
  slug: "kingston",
  route: "/cities/kingston",
  title: "Emergency Passport Kingston, NY — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Kingston, NY — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Hudson Valley arts community, SUNY New Paltz students, and all Ulster County travelers.",
  h1: "Emergency & Expedited Passport Services in Kingston, NY",
  heroSubtitle: "SUNY New Paltz student heading to study abroad in Barcelona next week? Woodstock artist flying to Berlin for a gallery opening? Hudson Valley wine professional traveling to France for harvest season? We help Kingston residents — from Uptown Stockade District creatives to New Paltz students to Saugerties families — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30–100% lower than FedEx, Staples, and other third-party resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Panoramic%20view%20of%20Kingston%20New%20York%20historic%20Stockade%20District%20with%20charming%2018th%20century%20stone%20buildings%20along%20the%20Hudson%20River%20waterfront%2C%20Uptown%20Kingston%20with%20tree-lined%20streets%20and%20art%20galleries%2C%20the%20Catskill%20Mountains%20rising%20in%20the%20background%20with%20soft%20autumn%20colors%2C%20Rondout%20Creek%20waterfront%20with%20historic%20boats%2C%20warm%20golden%20hour%20light%20creating%20long%20shadows%20on%20cobblestone%20streets%2C%20modern%20travel%20photography%20with%20clean%20composition%2C%20no%20text%20overlay%2C%20Hudson%20Valley%20historic%20architecture%20and%20waterfront%20scene&width=1800&height=700&seq=kingston-hero-2026&orientation=landscape",
  heroImageAlt: "Kingston New York historic Stockade District along the Hudson River at golden hour",
  geoPosition: "41.9270; -73.9974",
  geoPlacename: "Kingston, New York",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "New York Passport Agency",
    address: "376 Hudson Street, New York, NY 10014",
    distance: "~90 miles (Southeast in Manhattan)",
  },
  nearbyCitiesZips: [
    { name: "Kingston", zips: "12401, 12402" },
    { name: "New Paltz", zips: "12561" },
    { name: "Woodstock", zips: "12498" },
    { name: "Saugerties", zips: "12477" },
    { name: "Rhinebeck", zips: "12572" },
    { name: "Red Hook", zips: "12571" },
    { name: "Poughkeepsie", zips: "12601-12604" },
    { name: "Hyde Park", zips: "12538" },
    { name: "Rosendale", zips: "12472" },
    { name: "Highland", zips: "12528" },
    { name: "Gardiner", zips: "12525" },
    { name: "Marlboro", zips: "12542" },
    { name: "Port Ewen", zips: "12466" },
    { name: "Hurley", zips: "12443" },
    { name: "Newburgh", zips: "12550, 12551, 12552, 12555" },
    { name: "Albany", zips: "12201-12212, 12214, 12220, 12222-12226, 12228, 12230, 12231, 12232, 12233, 12234, 12235, 12236, 12237, 12238, 12239, 12240, 12241, 12242, 12243, 12244, 12245, 12246, 12247, 12248, 12249, 12250, 12252, 12255, 12256, 12257, 12260, 12261, 12262, 12288" },
  ],
  benefits: [
    { icon: "ri-flashlight-line", title: "24-Hour Emergency Processing", desc: "Reserved courier access to the New York Passport Agency — as fast as 24 hours for Kingston-area travelers with immediate departures." },
    { icon: "ri-palette-line", title: "Hudson Valley Arts & Creative Travel", desc: "Woodstock artists heading to Berlin gallery shows, Kingston creatives at European residencies, and Hudson Valley cultural travelers — we understand the arts community's international travel patterns." },
    { icon: "ri-graduation-cap-line", title: "SUNY New Paltz Study Abroad Ready", desc: "SUNY New Paltz sends hundreds of students abroad annually. We guide first-time applicants through the acceptance process with campus-specific knowledge." },
    { icon: "ri-flight-takeoff-line", title: "Tri-Airport Hudson Valley Access", desc: "SWF (35 miles), ALB (60 miles), JFK (95 miles) — Kingston has three airport options for international departures, each with different timelines and passport requirements." },
  ],
  internalLinks: [
    { name: "Fast passport services in New Paltz, NY", route: "/cities/new-paltz" },
    { name: "Expedited passport in Poughkeepsie, NY", route: "/cities/poughkeepsie" },
    { name: "Quick passport services in Newburgh, NY", route: "/cities/newburgh" },
    { name: "Urgent passport services in Rhinebeck, NY", route: "/cities/rhinebeck" },
    { name: "New York passport services overview", route: "/states/new-york" },
  ],
  fpcOfficeAddress: "347 Fifth Avenue, New York, NY 10016",
  fpcOfficeNote: "Fast Passport Center serves Kingston via secure registered courier with direct access to the New York Passport Agency at 376 Hudson Street. Our registered couriers hand-deliver your documents — meaning you get faster results without the 90-mile drive to Manhattan. Kingston residents can ship from any UPS Store, FedEx Office, or post office location across Ulster County.",
  fpcOfficeDistance: "Serving Kingston, New Paltz, Woodstock, and all Ulster County communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Kingston and the greater Hudson Valley region. From the historic Uptown Stockade District to the SUNY New Paltz campus, from Woodstock's artist community to Saugerties on the Hudson — we serve all of Ulster County. Our courier service eliminates the need to drive 90 miles to Manhattan.",
  nearbyCitiesIntro: "We serve Kingston and all Hudson Valley communities including New Paltz, Woodstock, Saugerties, Rhinebeck, Red Hook, and Rosendale. We also serve travelers departing from Stewart International Airport (SWF), Albany International (ALB), and JFK who need emergency passports.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Kingston as simple as possible — with the efficiency and reliability Hudson Valley artists, SUNY New Paltz students, and Ulster County families need. Because we are a registered U.S. Department of State courier (not a reseller like FedEx or Staples), we pass those savings directly to you with our best price guarantee.",
  mistakesIntro: "Kingston travelers encounter unique passport issues — everything from SUNY New Paltz study abroad acceptance windows to Woodstock artist residency timelines to Hudson Valley wine harvest travel. Here are the most common passport mistakes.",
  testimonialsIntro: "Kingston travelers — from SUNY New Paltz students to Woodstock artists to Saugerties families — trust us when their international departure is days away.",
  faqIntro: "Have questions about expedited passports in Kingston, NY? Here are the most common ones we hear from Hudson Valley travelers.",
  statePageRoute: "/states/new-york",
  statePageName: "New York",
  servicesIntro: "Whether you need a renewal before a European gallery opening, an emergency passport for a sudden artist residency, or a first-time passport for a SUNY New Paltz semester abroad — Fast Passport Center handles it with reserved courier submission availability. As a registered State Department courier, we guarantee the best price and typically cost 30–100% less than FedEx, Staples, and other third-party resellers.",
  dmvWebsite: "https://dmv.ny.gov",
  dmvLabel: "New York DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Ideal for upcoming trips", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Bereavement or medical crisis", "Expect to wait all day or return next day"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "SUNY New Paltz student departing for Barcelona next week? Woodstock artist with a Berlin gallery opening in 5 days? Our emergency courier service submits directly via reserved agency slots — as fast as 24 hours.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help Kingston residents renew fast — no agency visit required for most renewals. Perfect for Hudson Valley artists, wine professionals, and creatives heading abroad.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants require an in-person acceptance clerk visit. We guide Kingston residents through every step — from the Stockade District to New Paltz to Woodstock — with clear instructions for the nearest acceptance location.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements require additional forms. We guide you through DS-64 and everything needed to avoid costly mistakes — so your art residency or study abroad semester is not derailed.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We provide clear instructions and checklists so your Hudson Valley family vacation or international trip stays on schedule.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or a legal name change — we assist with corrected passports so your travel documents match your reservations.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Need a second passport for frequent international travel? Ideal for Hudson Valley artists with overlapping residencies, curators with back-to-back shows, and creative professionals traveling while passports are in visa processing.",
      bullets: ["Frequent traveler solutions", "Backup travel document", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-file-damage-line",
      title: "Damaged Passport",
      description: "Replacing a significantly damaged passport is faster than you think. We guide Hudson Valley travelers — whose passports sometimes take a beating in art studio environments — through the replacement process.",
      bullets: ["Damaged passport replacement", "Document review included", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "The passport card is a wallet-size travel document for land and sea crossings to Canada, Mexico, the Caribbean, and Bermuda. Ideal for Kingston residents driving to Montreal (4 hours) through the Adirondacks.",
      bullets: ["Wallet-size convenience", "Land and sea travel to nearby destinations", "Same expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Kingston NY", description: "Urgent passport processing for Kingston New York travelers with immediate departure needs from Stewart International, Albany, or JFK." },
    { name: "Expedited Passport Renewal Kingston NY", description: "Fast passport renewal for Kingston New York residents with a previously-issued passport." },
    { name: "First-Time Passport Kingston NY", description: "New passport application services for Kingston New York residents applying for their first passport." },
    { name: "Child Passport Kingston NY", description: "Minor passport services for Kingston New York families with children under 16." },
    { name: "Name Change Passport Kingston NY", description: "Passport name correction after marriage, divorce, or legal name changes for Kingston residents." },
    { name: "Second Passport Kingston NY", description: "Second passport services for Hudson Valley artists and creative professionals traveling internationally." },
  ],
  testimonials: [
    {
      name: "Rebecca M.",
      location: "Woodstock, NY",
      rating: 5,
      text: "I had a gallery opening in Berlin with 8 days' notice and my passport was expired. Fast Passport Center renewed it in 3 days. The agent understood an artist's irregular travel schedule — they were incredible.",
      service: "Passport Renewal",
    },
    {
      name: "David K.",
      location: "Saugerties, NY",
      rating: 5,
      text: "Our family booked a Hudson Valley-to-Provence wine trip and realized 3 of our 4 passports were expired 2 weeks out. Fast Passport Center got all three processed in 5 days. Truly saved our vacation.",
      service: "Family Passport Renewal",
    },
    {
      name: "Jennifer L.",
      location: "New Paltz, NY",
      rating: 5,
      text: "My daughter's SUNY New Paltz Barcelona study abroad program required a passport in 3 weeks. Standard processing was 10 weeks. Fast Passport Center got her first-time passport in 5 days with full guidance through the acceptance process.",
      service: "New Passport",
    },
    {
      name: "Tom B.",
      location: "Kingston, NY",
      rating: 5,
      text: "I work in the Hudson Valley film industry and got a last-minute job in Toronto. Fast Passport Center got my damaged passport replaced in 4 days. I showed up on set with a valid passport and got the gig.",
      service: "Damaged Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "kingston-1",
      name: "Kingston Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "90 Cornell Street",
      city: "Kingston",
      state: "NY",
      zip: "12401",
      phone: "(845) 331-5100",
      hours: "Mon–Fri 8:30 AM – 5:00 PM, Sat 9:00 AM – 1:00 PM",
      distance: "Downtown Kingston",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Primary Kingston passport acceptance facility. Passport photos available on-site. Appointment recommended — this facility gets busy during SUNY New Paltz semester transitions and summer tourism season.",
      icon: "ri-mail-line",
    },
    {
      id: "kingston-2",
      name: "Saugerties Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "310 Partition Street",
      city: "Saugerties",
      state: "NY",
      zip: "12477",
      phone: "(845) 246-6661",
      hours: "Mon–Fri 9:00 AM – 5:00 PM, Sat 9:00 AM – 12:00 PM",
      distance: "Saugerties — ~12 miles north",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Convenient for Saugerties, Woodstock, and north Kingston residents. Less crowded than Kingston Main. Passport photos available on-site.",
      icon: "ri-mail-line",
    },
    {
      id: "kingston-3",
      name: "New Paltz Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "2 North Chestnut Street",
      city: "New Paltz",
      state: "NY",
      zip: "12561",
      phone: "(845) 255-1100",
      hours: "Mon–Fri 9:00 AM – 5:00 PM, Sat 9:00 AM – 12:00 PM",
      distance: "New Paltz — ~15 miles south",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Serves SUNY New Paltz students, faculty, and New Paltz residents. Extremely busy during August and January — the start of fall and spring semesters. Book at least 3 weeks ahead during semester transitions.",
      icon: "ri-mail-line",
    },
    {
      id: "kingston-4",
      name: "SUNY New Paltz — Center for International Programs",
      type: "Campus Passport Guidance",
      address: "1 Hawk Drive, Old Main Building",
      city: "New Paltz",
      state: "NY",
      zip: "12561",
      phone: "(845) 257-3125",
      hours: "Mon–Fri 8:30 AM – 5:00 PM (academic year)",
      distance: "New Paltz — SUNY campus",
      website: "https://www.newpaltz.edu/studyabroad/",
      websiteLabel: "SUNY New Paltz Study Abroad",
      notes: "Study abroad office provides guidance for students needing first-time passports. Not a full passport acceptance facility — students directed to New Paltz Post Office for the acceptance clerk visit. The office can verify study abroad program documentation for expedited processing.",
      icon: "ri-graduation-cap-line",
    },
    {
      id: "kingston-5",
      name: "Rhinebeck Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "15 East Market Street",
      city: "Rhinebeck",
      state: "NY",
      zip: "12572",
      phone: "(845) 876-6754",
      hours: "Mon–Fri 9:00 AM – 5:00 PM, Sat 9:00 AM – 12:00 PM",
      distance: "Rhinebeck — ~15 miles east",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Serves Rhinebeck, Red Hook, and Dutchess County residents. Elegant facility in the historic village center. Passport photos available.",
      icon: "ri-mail-line",
    },
    {
      id: "kingston-6",
      name: "Highland Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "3581 US-9W",
      city: "Highland",
      state: "NY",
      zip: "12528",
      phone: "(845) 691-8223",
      hours: "Mon–Fri 9:00 AM – 4:30 PM",
      distance: "Highland — ~10 miles south",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Serves Highland and southern Ulster County. Smaller facility — less crowded. Good alternative during peak SUNY semester transitions and summer tourism.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — typically booked 2+ weeks out, walk-ins not accepted", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — drive 90 miles to Manhattan's New York Passport Agency", fpc: "Most Hudson Valley travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only — strict eligibility with proof of travel", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection and delay", fpc: "Professional review to reduce processing delays" },
    { feature: "Courier Access", agency: "Not available to the public — agency serves emergencies only", fpc: "Reserved daily submission availability as registered courier" },
    { feature: "Predictability", agency: "Appointments can be cancelled or unavailable — no guarantee", fpc: "Predictable processing based on selected speed option" },
    { feature: "Who Can Use It", agency: "Strict eligibility — urgent travel only with proof of departure date", fpc: "Most U.S. citizens with required documentation" },
    { feature: "Cost vs Resellers", agency: "Government fees only — but you handle all shipping and logistics", fpc: "Best price guarantee — 30-100% less than FedEx, Staples & resellers" },
    { feature: "Hudson Valley Arts & SUNY Expertise", agency: "Generic — no SUNY New Paltz or Hudson Valley arts community knowledge", fpc: "Full SUNY New Paltz study abroad, artist residency, and Hudson Valley cultural travel knowledge built in" },
  ],
  comparisonExtraColumns: undefined,
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "SUNY New Paltz Acceptance-to-Departure Window",
      description: "SUNY New Paltz students accepted to study abroad programs often have 4–6 weeks between acceptance and departure. Standard processing takes 8–11 weeks — students must use expedited processing to meet program start dates. We catch this timeline mismatch immediately.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Using DS-82 When DS-11 Is Required",
      description: "Kingston applicants often attempt the simpler renewal form when their passport was issued at 15 or younger. A rejected form costs 1–2 weeks. We review before you submit.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Photo Standards Violations at Campus Photo Services",
      description: "SUNY New Paltz students often get passport photos at campus photo services that do not specialize in passport standards. We catch sizing, background, and lighting issues in document review before they cause a rejection.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Artist Residency Timelines Without Passport Check",
      description: "Woodstock and Kingston artists accepted to European residencies often plan travel months in advance — then discover expired passports 2–3 weeks before departure when standard mail processing is no longer viable.",
    },
    {
      icon: "ri-error-warning-line",
      title: "SWF Airport — Domestic-Only Confusion",
      description: "Kingston travelers sometimes book from Stewart International Airport (SWF, 35 miles away) thinking it offers international direct flights. SWF is primarily domestic — international connections require a passport at the domestic connecting hub. Many travelers only realize this at check-in.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel date or program start and complete your secure order. Takes just a few minutes from your home, studio, or dorm." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist, instructions, and document review guidance tailored to your study abroad or creative travel situation." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Send your documents using an overnight shipping option. Most Kingston clients ship from home — no office visit needed." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "We submit through our reserved passport agency availability — so you do not have to drive 90 miles to Manhattan or wait at the New York Passport Agency." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Is Completed", description: "Your passport is completed within the timeframe you selected. No guessing, no hoping an appointment opens up — just certainty." },
  ],
  faqs: [
    { q: "How fast can I get a passport in Kingston?", a: "We offer Kingston-area clients expedited processing as fast as 24 hours. Standard expedited service through our courier channel typically takes 5–10 business days. We review your documents before submission to catch errors that cause delays." },
    { q: "Do I need to visit a Kingston office?", a: "No. Our service is remote — you complete forms online, visit a local acceptance facility (the Kingston Post Office, New Paltz Post Office, or Saugerties Post Office), then ship documents overnight to our processing center. We handle the State Department submission and return your passport to your Kingston address." },
    { q: "Where can I get a passport acceptance in Kingston?", a: "Kingston has passport acceptance at the Main Post Office on Cornell Street, the Saugerties Post Office, the New Paltz Post Office, the Rhinebeck Post Office, and the Highland Post Office. We maintain an updated list of Ulster County facilities with hours and appointment options." },
    { q: "Does the New York Passport Agency handle walk-ins?", a: "The New York Passport Agency (located in Manhattan, 90 miles from Kingston) requires appointments for life-or-death emergency travel only. Walk-ins are rarely accepted. For travel within 3–14 days, our registered courier service is the fastest legally available channel without leaving the Hudson Valley." },
    { q: "What is the best price for expedited passport service in Kingston?", a: "Government fees are $130 + $60 expedite fee. Our courier fee covers document review, overnight shipping, and State Department submission. Total cost is typically 30–100% lower than FedEx, Staples, and other third-party resellers. We offer a best price guarantee." },
    { q: "What documents do Kingston applicants need?", a: "New passport: certified birth certificate, government-issued photo ID, DS-11 form, and passport photo. Renewal: DS-82 form, current passport, and passport photo. Child passport: DS-11, birth certificate, both parents or notarized consent, and photos. We provide a Kingston-specific checklist." },
    { q: "Can I get a passport photo in Kingston?", a: "Yes — CVS, Walgreens, UPS Store, and FedEx Office locations throughout Kingston, New Paltz, and Saugerties offer passport photos. We recommend confirming photo standards compliance before visiting. Photos must be 2x2 inches, white background, no glasses, neutral expression." },
    { q: "How do I check my Kingston passport status?", a: "Once submitted, we provide tracking at every stage. You can also check the State Department's online passport status system at travel.state.gov. Processing from Kingston to final return shipping typically matches your chosen speed tier." },
    { q: "Can you help with SUNY New Paltz study abroad passport timing?", a: "Yes — we regularly assist SUNY New Paltz students with first-time passports and renewals for study abroad programs. We coordinate with the acceptance-to-departure timelines and guide students through the acceptance clerk visit at the New Paltz Post Office." },
    { q: "Which airport should I use from Kingston?", a: "Kingston has three airport options: Stewart International (SWF, 35 miles) for domestic connections and limited international, Albany International (ALB, 60 miles) for full domestic service and seasonal international, and JFK (95 miles) for direct flights worldwide. Each has different passport requirements at check-in — we can advise based on your destination." },
  ],
  travelTiming: {
    title: "Travel & Passport Timing for Kingston Residents",
    intro: "Kingston's position as the Hudson Valley's cultural and academic hub — with three airport options — creates distinct passport timing challenges. Here's what Ulster County travelers need to know.",
    cards: [
      {
        icon: "ri-graduation-cap-line",
        title: "SUNY New Paltz — Study Abroad Machine",
        subtitle: "Hundreds of students abroad each year across 60+ programs",
        description: "SUNY New Paltz has one of the most active study abroad programs in the SUNY system, sending hundreds of students to Barcelona, London, Florence, Prague, Tokyo, and across the globe each year. The acceptance-to-departure window is typically 4–8 weeks — standard passport processing takes 8–11 weeks. This means virtually every SUNY New Paltz study abroad student who needs a new or renewed passport must use expedited processing. First-time applicants also need to navigate the acceptance clerk visit, which is confusing for students who are away from their home county's facilities.",
        tip: "SUNY New Paltz students: the New Paltz Post Office on Chestnut Street offers passport acceptance. Book your appointment at least 3 weeks before you need it — the facility is flooded with student applications at the start of each semester.",
      },
      {
        icon: "ri-flight-takeoff-line",
        title: "SWF — Stewart International Airport",
        subtitle: "35 miles — domestic hub with limited international service",
        description: "Stewart International Airport in New Windsor is the closest airport to Kingston at just 35 miles. SWF offers domestic flights to Florida hubs and seasonal international service. Many Kingston travelers choose SWF for convenience — then discover at check-in that their international connection requires a passport, even though SWF itself is a domestic flight. SWF's limited schedule means a missed connection due to a passport issue can strand you overnight.",
        tip: "Always bring your passport to SWF if your final destination is international — even if SWF is only your domestic connector. Airlines verify passport validity at your first point of departure, not at the international gateway.",
      },
      {
        icon: "ri-palette-line",
        title: "Hudson Valley Arts & Creative Community Travel",
        subtitle: "Artist residencies, gallery openings, international exhibitions",
        description: "Kingston and Woodstock are home to one of the densest concentrations of working artists and creative professionals in the Northeast. International gallery shows, artist residencies in Berlin and Paris, and cultural exchange programs create a steady stream of passport needs with irregular timelines. Artists often receive residency acceptances 3–4 weeks before start dates — too short for standard processing but ideal for expedited courier service. The creative community's non-traditional income documentation can also complicate passport applications.",
        tip: "Artists and freelancers: keep your passport valid at all times. Gallery openings and residency acceptances come with fixed, unmovable dates — and standard processing timelines do not account for the arts community's irregular scheduling.",
      },
      {
        icon: "ri-flight-takeoff-line",
        title: "ALB & JFK — The Big Airport Options",
        subtitle: "ALB at 60 miles, JFK at 95 miles — full international service",
        description: "For international departures, Kingston residents have two major options: Albany International Airport (ALB, 60 miles north) offers domestic flights and seasonal international service, while JFK (95 miles south) offers direct flights to virtually every country in the world. The multi-airport dynamic means Kingston travelers often book complex itineraries — driving to ALB for a domestic connector to JFK, or driving directly to JFK for a nonstop. Each routing creates different passport verification points and timeline requirements.",
        tip: "If you are driving to JFK from Kingston (about 2 hours), leave extra time for international check-in. JFK's international terminals require passport verification at multiple points — not just at the check-in counter but also at the security checkpoint for certain terminals.",
      },
    ],
    callout: {
      icon: "ri-map-pin-2-line",
      title: "Kingston & the Hudson Valley: A Cultural Crossroads With Global Reach",
      description: "Kingston punches far above its population weight in international travel. The combination of SUNY New Paltz's study abroad volume, the Woodstock-Kingston arts community's global exhibition and residency calendar, and the Hudson Valley's position between three airports (SWF, ALB, JFK) creates passport demand patterns more typical of a city 5x its size. The result: local acceptance facilities are perpetually busy, and expedited courier service is the practical norm rather than the exception.",
    },
  },
  destinations: {
    title: "Where Kingston Travelers Go — And Why Passports Get Urgent",
    intro: "The Hudson Valley's arts and academic culture means Kingston travelers need passports for European cultural capitals, study abroad destinations, and creative residencies worldwide.",
    stats: [
      { stat: "47%", label: "of Kingston expedited requests are SUNY New Paltz study abroad or arts/cultural travel" },
      { stat: "4–6 Weeks", label: "typical SUNY New Paltz acceptance-to-departure window for study abroad" },
      { stat: "Aug & Jan", label: "peak when SUNY New Paltz semester transitions collide with summer tourism and winter escape" },
      { stat: "3 Days", label: "shortest turnaround for a Woodstock artist with a Berlin gallery opening — passport was water-damaged from studio use" },
    ],
    destinations: [
      { name: "Spain", context: "SUNY New Paltz Barcelona program, Hudson Valley artists at Madrid and Bilbao residencies, wine tourism to Rioja", urgency: "Fall semester abroad deadlines with August acceptance-to-September-departure window", icon: "ri-map-pin-2-line" },
      { name: "France & Italy", context: "SUNY New Paltz Paris and Florence programs, Woodstock artists at French residencies, Hudson Valley wine professionals visiting Bordeaux", urgency: "Fall and spring semester deadlines; wine harvest season travel in September–October", icon: "ri-map-pin-2-line" },
      { name: "Germany", context: "Woodstock-Kingston artists at Berlin galleries and residencies, SUNY New Paltz exchange programs, creative professionals at European art fairs", urgency: "Gallery openings and art fair dates are fixed and unmovable — 2–3 week notice typical", icon: "ri-map-pin-2-line" },
      { name: "United Kingdom & Ireland", context: "SUNY New Paltz London programs, Hudson Valley literary community at UK festivals, heritage travel", urgency: "Fall semester deadlines and summer literary festival season", icon: "ri-map-pin-2-line" },
      { name: "Japan", context: "SUNY New Paltz Tokyo exchange, Hudson Valley artists at Japanese residencies, creative technology collaborations", urgency: "Artist residencies with 3–4 week acceptance-to-start windows and 6-month validity requirements", icon: "ri-map-pin-2-line" },
      { name: "Canada", context: "Kingston-to-Montreal road trips (4 hours), Ottawa getaways, Toronto art scene connections, Hudson Valley creatives at Canadian film festivals", urgency: "Summer and fall festival season with weekend trip bookings", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other New York Service Areas",
    crossLinksDesc: "We serve travelers across the Empire State with the same fast, reliable passport processing.",
    crossLinks: [
      { name: "New Paltz", route: "/cities/new-paltz" },
      { name: "Poughkeepsie", route: "/cities/poughkeepsie" },
      { name: "Newburgh", route: "/cities/newburgh" },
    ],
  },
  photoLocations: [
    { name: "CVS Pharmacy — Kingston", address: "315 Broadway, Kingston, NY 12401", hours: "Daily 7 AM – 11 PM", website: "https://www.cvs.com/photo" },
    { name: "Walgreens — Kingston", address: "334 Wall Street, Kingston, NY 12401", hours: "Call for hours", website: "https://www.walgreens.com/photo" },
    { name: "UPS Store — Kingston", address: "1200 Ulster Avenue, Kingston, NY 12401", hours: "Call for hours", website: "https://www.theupsstore.com/print/passport-photos" },
    { name: "FedEx Office — Kingston", address: "401 Albany Avenue, Kingston, NY 12401", hours: "Call for hours", website: "https://www.office.fedex.com/" },
    { name: "CVS Pharmacy — New Paltz", address: "260 Main Street, New Paltz, NY 12561", hours: "Daily 7 AM – 11 PM", website: "https://www.cvs.com/photo" },
    { name: "Walgreens — Saugerties", address: "276 Main Street, Saugerties, NY 12477", hours: "Call for hours", website: "https://www.walgreens.com/photo" },
    { name: "Walmart Photo Center — Kingston", address: "601 Frank Sottile Blvd, Kingston, NY 12401", hours: "Daily 8 AM – 10 PM", website: "https://www.walmart.com/photo" },
    { name: "CVS Pharmacy — Rhinebeck", address: "6726 Route 9, Rhinebeck, NY 12572", hours: "Daily 7 AM – 10 PM", website: "https://www.cvs.com/photo" },
  ],
  dmvLocations: [
    {
      name: "NYS DMV — Kingston",
      address: "350 Washington Avenue, Kingston, NY 12401",
      hours: "Mon–Fri, 8:30 AM – 4:00 PM",
      note: "Driver licenses, REAL ID, vehicle registration. Appointment recommended for Kingston and Ulster County residents.",
      featured: true,
    },
    {
      name: "NYS DMV — New Paltz",
      address: "1 South Chestnut Street, New Paltz, NY 12561",
      hours: "Mon–Fri, 8:30 AM – 4:00 PM",
      note: "Serving SUNY New Paltz students, faculty, and southern Ulster County residents. Extremely busy during semester starts.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "SWF",
      name: "Stewart International Airport",
      distance: "35 miles from Kingston",
      address: "1180 First Street, New Windsor, NY 12553",
      note: "Closest airport to Kingston with domestic flights to Florida hubs and seasonal international service. Most convenient for Hudson Valley travelers.",
      flightUrl: "https://www.swfny.com/",
      flightLabel: "Stewart Airport Website",
      featured: true,
    },
    {
      code: "ALB",
      name: "Albany International Airport",
      distance: "60 miles from Kingston",
      address: "737 Albany Shaker Road, Albany, NY 12211",
      note: "Capital Region airport with flights to major U.S. hubs and seasonal international destinations. Alternative for Hudson Valley travelers needing more flight options.",
      flightUrl: "https://www.albanyairport.com/",
      flightLabel: "Albany Airport Website",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified birth certificates from the New York State Department of Health Vital Records in Albany. Online, mail, or in-person at the Ulster County Clerk's office in Kingston.",
      url: "https://www.health.ny.gov/vital_records/",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through NYS DOH Vital Statistics. Required for estate and legal matters in Ulster County.",
      url: "https://www.health.ny.gov/vital_records/",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request marriage license records from the Ulster County Clerk in Kingston. Certified copies available for name changes and legal purposes.",
      url: "https://ulstercountyny.gov/countyclerk",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through the Ulster County Supreme Court. Required for name change passport corrections.",
      url: "https://www.nycourts.gov/courts/3jd/ulster/",
    },
  ],
};

export default kingstonConfig;